export default {
  hostname: 'https://finsite.me',
  production: window.location.hostname !== 'localhost',
  site: {
    title: 'Финсайт',
    email: 'hello@finsite.me'
  }
}
